export default __webpack_public_path__ + "static/media/telegram.754f221f.png";